export default "__VITE_ASSET__rUryqW4o__"